import { render, staticRenderFns } from "./editProtocol.vue?vue&type=template&id=5474db2a"
import script from "./editProtocol.vue?vue&type=script&lang=js"
export * from "./editProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports